import { CPProductName } from "./CPProducts.js";
import { YM_Category } from "../model/MediaMetaData.js";
import { NielsenTrackingIdMapping } from "../modules/stats/collectors/NielsenCollector.js";

const fanpageDefaultAppId = "P3036DD51-7DC5-45A3-9C61-7B9296541793"
const fanpagePoliticsAppId = "P1BFAA463-9E68-4B49-AF9D-05C301DCF31D"
const innovazioneAppId = "P39855AA7-33AA-4B79-A6E0-BAD6E43125ED"
const spettacoloAppId = "P348C95BF-9419-49D6-AA2B-A1DA5681226D"
const sportAppId = "P68F8907D-E724-457A-AA77-4053B6E02D89"

export const NielsenVideoMeasurementTrackingIds: {[k in CPProductName]?: NielsenTrackingIdMapping } = {
    COOKIST: {
        default: "P96D5F1C9-54C1-4614-BE69-6CDAC5AECB8E"
    },
    OHGA: {
        default: "PE3E2ABC2-A5A4-4E3D-80C1-80186DE178FA",
    },
    KODAMI: {
        default: "P88A2EDA4-E3F8-461C-909C-569AE2BF6E11",
    },
    FANPAGE: {
        default: fanpageDefaultAppId,
        categorized: {
            [YM_Category.Donna]: "PDF881C47-90AF-41B3-9A0E-886271CCB52B",
            [YM_Category.Motori]: "PAD8DA55F-E00A-4D0D-91CF-07D932B92F68",
            [YM_Category.Viaggi]: "P494B6C6D-1EBD-47F6-A96F-C86863C365D8",
            [YM_Category.Sport]: sportAppId,
            [YM_Category.Rugby]: sportAppId,
            [YM_Category.Cronaca]: fanpagePoliticsAppId,
            [YM_Category.Politica]: fanpagePoliticsAppId,
            [YM_Category.Tecnologia]: innovazioneAppId,
            [YM_Category.Scienze]: innovazioneAppId,
            [YM_Category.Design]: innovazioneAppId,
            [YM_Category.Cucina]: "PCF811A00-5F44-425B-95F2-B1D5C79BBA49",
            [YM_Category.Spettacolo]: spettacoloAppId,
            [YM_Category.Musica]: spettacoloAppId
        }
    },
    // LEXPLAIN: {
    // },
    // WAMILY: {
    // },
    GEOPOP: {
        default: "P794741DF-9E57-4F5F-979F-DDFD338706FB",
    }
}